'use strict';

var PooledHeaderDirective = function PooledHeaderDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/pooled-header.html'),
    requires: '^rmNewPooledSeasonalityCalendar',
    scope: false
  };
};
PooledHeaderDirective.$inject = [];
module.exports = PooledHeaderDirective;